






















































































































































































































































































































































































































import Vue from 'vue';
import {dataService} from '../services/data.service';
import {Einrichtung} from '@/models/einrichtung';
import {Vorgang} from '@/models/vorgang';

export default Vue.extend({
    name: 'schritte',
    data() {
        return {
            e1: 1,
            steps: 2,
            vertical: false,
            altLabels: false,
            editable: true,
            dialog: false,
            patient_abfrage: 'ja',
            einrichtungen_abfrage: 'Alle',
            vn_vorname: '',
            vn_nachname: '',
            einrichtungen: Array(new Einrichtung()),
            einwilligung_einrichtungen: false,
            einwilligung_gesundheitsdaten: false,
            einwilligung_datenweitergabe: false,
            dialog_einrichtungen: false,
            dialog_gesundheitsdaten: false,
            dialog_datenweitergabe: false,
            dialog_abbruch: false,
            gesellschaft: '',
            vorgang: new Vorgang(),
            vorgangsId: this.$route.params.id,
        };
    },
    mounted() {
        dataService
            .ladeVorgang(this.$route.params.id)
            .then((response: any) => {
                this.vorgang = dataService.vorgang;
                this.einwilligung_datenweitergabe = dataService.vorgang.einwilligungDatenweitergabe;
                this.einwilligung_einrichtungen = dataService.vorgang.einwilligungEinrichtung;
                this.einwilligung_gesundheitsdaten = dataService.vorgang.einwilligungGesundheitsdaten;
                this.patient_abfrage = dataService.vorgang.vertreter ? 'nein' : 'ja';
                this.vn_vorname = dataService.vorgang.vertreterVorname;
                this.vn_nachname = dataService.vorgang.vertreterNachname;
                this.einrichtungen = dataService.vorgang.einrichtungen;
                this.einrichtungen_abfrage = dataService.vorgang.einrichtung;
                this.gesellschaft = dataService.vorgang.vorgangsMetadaten.mandantName;
                if (this.einrichtungen.length === 0) {
                    this.neueEinrichtung();
                }
            });
    },
    watch: {
        steps(val) {
            if (this.e1 > val) {
                this.e1 = val;
            }
        },
        einrichtungen_abfrage() {
            if (this.einrichtungen_abfrage === 'Alle') {
                this.einrichtungen = [];
                this.neueEinrichtung();
            }
        },
        einwilligung_einrichtungen() {
            dataService.vorgang.einwilligungEinrichtung = this.einwilligung_einrichtungen;
        },
        einwilligung_gesundheitsdaten() {
            dataService.vorgang.einwilligungGesundheitsdaten = this.dialog_gesundheitsdaten;
        },
        einwilligung_datenweitergabe() {
            dataService.vorgang.einwilligungDatenweitergabe = this.einwilligung_datenweitergabe;
        }
    },
    methods: {
        neueEinrichtung() {
            this.einrichtungen.push({name: '', einrichtung: '', ort: ''});
        },
        loescheEinrichtung(index: number) {
            this.einrichtungen.splice(index, 1);
        },
        zurueck() {
            if (this.e1 === 1) {
                this.$router.push('/einfuehrung/'.concat(this.$route.params.id));
            }
            this.e1--;
        },
        weiter(schritt: number) {
            if (schritt === 2) {
                dataService.vorgang.vertreter = (this.patient_abfrage === 'nein');
                dataService.vorgang.vertreterNachname = this.vn_nachname;
                dataService.vorgang.vertreterVorname = this.vn_vorname;
            }
            if (schritt === 3) {
                dataService.vorgang.einrichtung = this.einrichtungen_abfrage;
                dataService.vorgang.einrichtungen = this.einrichtungen;
                dataService.vorgang.einwilligungDatenweitergabe = this.einwilligung_datenweitergabe;
                dataService.vorgang.einwilligungEinrichtung = this.einwilligung_einrichtungen;
                dataService.vorgang.einwilligungGesundheitsdaten = this.einwilligung_gesundheitsdaten;
            }
            dataService.speicherVorgang()
                .then(() => {
                    this.vorgang = dataService.vorgang;
                    this.e1 = schritt;
                });
        },
        abschliessen() {
            dataService.vorgang.vorgangsMetadaten.status = 'Gemeldet';
            dataService.speicherVorgang()
                .then(() => {
                    this.$router.push('/abschluss/'.concat(this.$route.params.id));
                });
        }
    }
});
